// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"onfido-sdk-ui-Select-wrapper","select":"onfido-sdk-ui-Select-select"};